<template>
  <span id="print-return-receipt-section">
    <el-button
      id="btn-print-return-receipt"
      type="success"
      @click="handleOpenDialog"
      size="mini"
      plain
    >
      {{ $t('coolerInventory.printReturnReceipt') }}
    </el-button>
  <el-dialog
    :close-on-click-modal="false"
    :title="$t('coolerInventory.printReturnReceipt')"
    :visible.sync="dialogVisible"
    width="65%"
    class="dialog-with-cols"
  >
    <el-form :model="printParams" :rules="formRules" ref="form" label-position="top" size="mini">
      <el-row>
        <el-col :md="8" :sm="12" :xs="24" class="form-vertical-item">
          <el-form-item :label="$t('coolerInventory.warehouse')">
            <el-input
              v-model="user.warehouseCode"
              class="inline-input"
              disabled
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="24" class="form-vertical-item">
          <el-form-item :label="$t('coolerInventory.dayOfService')" prop="dayOfService">
            <el-date-picker
              class="el-dropdown-new drop-sp date-dob"
              v-model="printParams.dayOfService"
              format="MM/dd/yyyy"
              type="date"
            ></el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :md="8" :sm="12" :xs="24" class="form-vertical-item">
          <el-form-item
            :label="$t('coolerInventory.shipper')"
            prop="shipperAccountId"
            class="shipper-filter shipper-wrp"
          >
            <autocomplete
              :model.sync="printParams.shipperAccountId"
              :url="urlShipperAutocomplete"
              labelField="name"
              labelFieldLastWithDash="number"
              valueField="id"
              ref="return-receipt-shipper"
            ></autocomplete>
            </el-form-item>
        </el-col>
      </el-row>
    </el-form>
    <div id="add-dialog-footer" slot="footer" class="dialog-footer form-vertical-item flex-reverse-direction">
      <el-button type="primary" id="form-print-button" @click="handlePrint()" size="mini">
        {{ $t('coolerInventory.print') }}
      </el-button>
      <el-button id="form-cancel-button" @click="dialogVisible = false" size="mini">
        {{ $t('common.cancel') }}
      </el-button>
    </div>
  </el-dialog>
</span>
</template>

<script>
import { mapGetters } from 'vuex';
import { Message } from 'element-ui';
import constants from '@/utils/constants';
import apiConstants from '@/utils/apiConstants';
import Autocomplete from '@/components/Autocomplete';

export default {
  name: 'PrintReturnReceipt',
  components: { Autocomplete },
  props: {
    shipperName: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters([
      'user',
      'coolerInventory'
    ]),
    urlShipperAutocomplete: () => apiConstants.END_POINTS.ACCOUNTS.SHIPPERS
  },
  data() {
    return {
      dialogVisible: false,
      printParams: {
        dayOfService: null,
        shipperAccountId: null
      },
      formRules: {
        dayOfService: [
          { required: true, message: this.$t('coolerInventory.error.dayOfServiceRequired'), trigger: 'blur' },
        ],
        shipperAccountId: [
          { required: true, message: this.$t('coolerInventory.error.shipperRequired'), trigger: 'blur' },
        ]
      },
    };
  },
  methods: {
    handleOpenDialog() {
      this.dialogVisible = true;
      this.printParams.dayOfService = this.coolerInventory.actualFilters.dayOfService;
      this.printParams.shipperAccountId = this.coolerInventory.actualFilters.shipperAccountId;
      this.$nextTick(() => {
        this.$refs['return-receipt-shipper'].setLocalModel(this.shipperName);
      });
    },
    async handlePrint() {
      await this.$refs.form.validate((valid) => {
        if (valid) {
          Message.closeAll();
          const loading = this.$loading(constants.LOADING.DEFAULT_CONFIG);
          this.$store
            .dispatch('coolerInventory/printReturnReceipt', this.printParams)
            .then((response) => {
              loading.close();
              this.$message.success(response.message);
            })
            .finally(() => loading.close());
        }
      });
    }
  }
};
</script>

<style rel="stylesheet/scss" lang="scss">
span#view-cooler-inventory {
  div.el-date-editor.el-dropdown-new, div.dropdown-warehouse.el-select--mini {
    width: 100%;
  }
}
</style>
